/* prettier-ignore */
export const conversionMap: Record<string, string> = {
  "bu-ws": "TERNARY_CUSTOM_LABEL/ws-bu",
  "cloud-ws": "TERNARY_CUSTOM_LABEL/ws-cloud",
  "Env Group": "TERNARY_CUSTOM_LABEL/Environment%20Group",
  "product-ws": "TERNARY_CUSTOM_LABEL/ws-product",
  "subscription-ws": "TERNARY_CUSTOM_LABEL/ws-subscription",
  amortizedCost: "FOCUS_SPEC_FIELD/EffectiveCost",
  aws_eks_cluster_name: "AWS_GENERATED_TAG/eks%3Acluster-name",
  aws_eks_deployment: "AWS_GENERATED_TAG/eks%3Adeployment",
  aws_eks_namespace: "AWS_GENERATED_TAG/eks%3Anamespace",
  aws_eks_node: "AWS_GENERATED_TAG/eks%3Anode",
  aws_eks_workload_name: "AWS_GENERATED_TAG/eks%3Aworkload-name",
  aws_eks_workload_type: "AWS_GENERATED_TAG/eks%3Aworkload-type",
  aws_line_item_operation: "AWS_BILLING_EXPORT_FIELD/line_item_operation",
  aws_reservation_arn: "AWS_BILLING_EXPORT_FIELD/reservation_reservation_a_r_n",
  aws_savings_plan_arn: "AWS_BILLING_EXPORT_FIELD/savings_plan_savings_plan_a_r_n",
  aws_usage_type_group: "AWS_BILLING_EXPORT_FIELD/product_group",
  awsNetUnblendedCost: "AWS_BILLING_EXPORT_FIELD/line_item_net_unblended_cost",
  awsReservationEffectiveCost: "AWS_BILLING_EXPORT_FIELD/reservation_effective_cost",
  awsSavingsPlanAmortizedUpfrontCommitmentForBillingPeriod: "AWS_BILLING_EXPORT_FIELD/savings_plan_amortized_upfront_commitment_for_billing_period",
  awsSavingsPlanEffectiveCost: "AWS_BILLING_EXPORT_FIELD/savings_plan_savings_plan_effective_cost",
  awsUsageBlendedCost: "AWS_BILLING_EXPORT_FIELD/line_item_blended_cost",
  azure_benefit_id: "AZURE_BILLING_EXPORT_FIELD/benefitId",
  azure_benefit_name: "AZURE_BILLING_EXPORT_FIELD/benefitName",
  azure_customer_name: "AZURE_BILLING_EXPORT_FIELD/customerName",
  azure_frequency: "AZURE_BILLING_EXPORT_FIELD/frequency",
  azure_meter_subcategory: "AZURE_BILLING_EXPORT_FIELD/meterSubCategory",
  azure_partner_earned_credit_rate: "AZURE_BILLING_EXPORT_FIELD/partnerEarnedCreditRate",
  azure_partner_name: "AZURE_BILLING_EXPORT_FIELD/partnerName",
  azure_partner_tenant_id: "AZURE_BILLING_EXPORT_FIELD/partnerTenantId",
  azure_product_id: "AZURE_BILLING_EXPORT_FIELD/ProductId",
  azure_product_name: "FOCUS_SPEC_FIELD/ProductName",
  azure_product_order_name: "AZURE_BILLING_EXPORT_FIELD/productOrderName",
  azure_reservation_id: "AZURE_BILLING_EXPORT_FIELD/reservationId",
  azure_reservation_name: "AZURE_BILLING_EXPORT_FIELD/reservationName",
  azure_resource_group_name: "AZURE_BILLING_EXPORT_FIELD/resourceGroupName",
  azure_resource_group: "AZURE_BILLING_EXPORT_FIELD/resourceGroupName",
  billingAccountId: "FOCUS_SPEC_FIELD/BillingAccountId",
  billingAccountName: "FOCUS_SPEC_FIELD/BillingAccountName",
  billingEntity: "AWS_BILLING_EXPORT_FIELD/bill_billing_entity",
  category: "FOCUS_SPEC_FIELD/ServiceCategory",
  cloud_provider: "FOCUS_SPEC_FIELD/ProviderName",
  cloudId: "TERNARY_MULTI_CLOUD_FIELD/cloud_id",
  cloudName: "TERNARY_MULTI_CLOUD_FIELD/cloud_name",
  commitmentPaymentModel: "AWS_BILLING_EXPORT_FIELD/pricing_purchase_option",
  cost: "FOCUS_SPEC_FIELD/BilledCost",
  customNetCost: "FOCUS_SPEC_FIELD/EffectiveCost",
  databaseEngine: "AWS_BILLING_EXPORT_FIELD/product_database_engine",
  LabelAncestryIDs: "GCP_BILLING_EXPORT_FIELD/ancestry_ids",
  LabelAncestryNames: "GCP_BILLING_EXPORT_FIELD/ancestry_names",
  LabelBillingAccountID: "FOCUS_SPEC_FIELD/BillingAccountId",
  LabelCategory: "FOCUS_SPEC_FIELD/ServiceCategory",
  LabelProjectID: "FOCUS_SPEC_FIELD/SubAccountId",
  LabelProjectName: "FOCUS_SPEC_FIELD/SubAccountName",
  LabelProjectNumber: "TERNARY_MULTI_CLOUD_FIELD/SubAccountNumber",
  LabelRegion: "FOCUS_SPEC_FIELD/RegionId",
  LabelServiceDescription: "FOCUS_SPEC_FIELD/ServiceName",
  LabelServiceID: "TERNARY_MULTI_CLOUD_FIELD/ServiceId",
  LabelSkuDescription: "FOCUS_SPEC_FIELD/ChargeDescription",
  LabelSkuID: "FOCUS_SPEC_FIELD/SkuId",
  LabelUsageUnit: "FOCUS_SPEC_FIELD/UsageUnit",
  LabelZone: "FOCUS_SPEC_FIELD/AvailabilityZone",
  lineItemType: "AWS_BILLING_EXPORT_FIELD/line_item_line_item_line_type",
  machine_family_category: "AWS_BILLING_EXPORT_FIELD/product_instance_family",
  machine_series_family: "AWS_BILLING_EXPORT_FIELD/product_instance_type_family",
  machine_spec: "AWS_BILLING_EXPORT_FIELD/product_instance_type",
  netAmortizedCost: "FOCUS_SPEC_FIELD/EffectiveCost",
  netCost: "FOCUS_SPEC_FIELD/EffectiveCost", // netCost, to fix default dashboard.
  oci_availability_domain: "OCI_BILLING_EXPORT_FIELD/product_availabilityDomain",
  oci_tenant_id: "OCI_BILLING_EXPORT_FIELD/lineItem_tenantId",
  operatingSystem: "AWS_BILLING_EXPORT_FIELD/product_operating_system",
  projectId: "FOCUS_SPEC_FIELD/SubAccountId",
  projectName: "FOCUS_SPEC_FIELD/SubAccountName",
  usageAmount: "FOCUS_SPEC_FIELD/ConsumedQuantity",
  usageAmountInPricingUnits: "GCP_BILLING_EXPORT_FIELD/usage_amount_in_pricing_units",
  user_benefits_domain_type: "AWS_USER_DEFINED_TAG/benefits%3Adomain-type",
  user_benefits_functional_area: "AWS_USER_DEFINED_TAG/benefits%3Afunctional-area",
  user_description: "AWS_USER_DEFINED_TAG/Description",
  user_eks_cluster_name: "AWS_USER_DEFINED_TAG/eks%3Acluster-name",
  user_environment: "AWS_USER_DEFINED_TAG/Environment",
  user_pcty_app_code: "AWS_USER_DEFINED_TAG/pcty%3Aapp-code",
  user_pcty_domain: "AWS_USER_DEFINED_TAG/pcty%3Adomain",
  user_pcty_env: "AWS_USER_DEFINED_TAG/pcty%3Aenv",
  user_pcty_environment: "AWS_USER_DEFINED_TAG/pcty%3Aenvironment",
  user_pcty_master_application_list_code: "AWS_USER_DEFINED_TAG/pcty%3Amaster-application-list-code",
  user_pcty_product: "AWS_USER_DEFINED_TAG/pcty%3Aproduct",
  user_service_group: "AWS_USER_DEFINED_TAG/Service_Group",
  vendor: "FOCUS_SPEC_FIELD/ProviderName",
};
